<template>
  <LockedUsers
    :title="$t('label.dashboardLockedAppUsers')"
    :access-label="$t('label.dashboardAppAccess')"
    :widget="widget"
    :view-all-to="{ name: 'User' }"
    :busy="busy"
    :permission="permission"
    @unlock="$emit('unlock', $event)"
    @retry="$emit('retry')"
    @page="$emit('page', $event)"
  />
</template>
<script>
import LockedUsers from "./LockedUsers.vue";
export default {
  name: "DashboardLockedAppUsers",
  components: { LockedUsers },
  props: {
    widget: { type: Object, required: true },
    busy: { type: Boolean, default: false },
    permission: { type: Number, default: 0 },
  },
};
</script>
